import request from "@/utils/request";

// 配置信息
// lilink=文献链接地址,ncbilink=NCBI链接地址,enlink=Ensembl链接地址,pdblink=PDB链接地址,banner=首页Banner图,portimg=首页入口图,datastatistics=首页数据统计,history=历史版本,progress=重要进展图片,wordcloud=RNA词云,publication=相关出版物,dataimg=数据统计图片,flink=友情链接
export const reqHomeData = (type) => request.post('/setting/setting', {type})

// 首页配置信息
export const reqIndexData = () => request.get('/setting/indexData')

// 链接配置
export const reqLinkSettingData = () => request.get('/setting/linkSetting')

// 表单提交
export const reqleaveMessage = (formData) => request.post('/message/leaveMessage', formData)

// 子数据分类
export const reqclassifyList = (params) => request.post('/classify/classifyList', params)

// species分类下rna标题
export const reqClassifyRnaList = (params) => request.post('/classify/rnaList', params)

// diseases分类下分类数据
export const reqDiseasesList = (params) => request.post('/classify/diseasesList', params)

// diseases分类下rna数据
export const reqDiseasesRNAList = (params) => request.post('/classify/diseasesRNAList', params)
export const reqDiseasesRNAListx = (params) => request.post('/classify/diseasesRNAListx', params)
export const reqDiseasesRNAListDrug = (params) => request.post('/classify/diseasesRNAListDrug', params)


// interaction分类下rna数据
export const reqinteractionList = (params) => request.post('/classify/interactionList', params)
export const reqinteractionListx = (params) => request.post('/classify/interactionListx', params)

// rna详情
export const reqLncrnaDetails = (id) => request.post('/lncrna/lncrnaDetails', id)

// 功能关系下rna列表
export const reqFunctionRNAList = (id) => request.post('/lncrna/functionRNAList', id)
export const reqFunctionRNAListx = (id) => request.post('/lncrna/functionRNAListx', id)

// Network图形列表
export const reqNetworkList = (params) => request.post('/network/networkList', params)

// Network图形列表
export const reqRNANetwork = (params) => request.post('/network/RNANetwork', params)

// 图形disease列表
export const reqdiseaseNetwork = (params) => request.post('/network/diseaseNetwork', params)

// 图形interaction列表
export const reqInteractionNetwork = (params) => request.post('/network/interactionNetwork', params)

// 下载列表
export const reqDownloadList = (params) => request.post('/download/downloadList', params)

// tools信息
export const reqToolsData = () => request.get('/setting/toolsData')

// 帮助中心
export const reqHelpsData = () => request.get('/setting/helpsData')

// statistic
export const reqStatisticData = () => request.get('/statistic/statistic')
// 统计
export const reqVisitor = () => request.get('/setting/visitor')

// 
export const reqLncrnaDetailsFunction = (association_id) => request.post('lncrna/lncrnaDetailsFunction', {association_id})
